import BaseObject from './base_object';

/**
 *
 *
 *
 */
export default class BaseModel extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'BaseModel';

    /**
     *
     */
    init(params){}
}
